import { render } from "./PlayerMatchMarkView.vue?vue&type=template&id=269e3cad"
import script from "./PlayerMatchMarkView.vue?vue&type=script&lang=js"
export * from "./PlayerMatchMarkView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__